export default {
  getStopList(state) {
    return state.stop_list
  },
  getOrganizationsList(state) {
    return state.my_organizations_list
  },
  getChildListOrganizators(state) {
    return state.childListOrganizators
  },
}